import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Person = lazy(() => import('./Person'))

export const TimeValidationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--time-validation']}>
    <Route index element={<Index />} />
    <Route path=':personId' element={<Person />} />
  </SubRouter>
))
